import { Link } from 'react-router-dom';
import { BrandLogo } from '../../components/BrandLogo';
import { HelpTip } from '../../components/HelpTip';

export function HomePage() {
  return (
    <main className="app-main stack">
      <BrandLogo />
      <div>
        <h1>Foundation Preview</h1>
        <p className="muted">TECH-01 menyiapkan struktur aplikasi per role sebelum database dipasang.</p>
      </div>
      <HelpTip>Gunakan empat kartu di bawah untuk memeriksa struktur tampilan awal setiap role.</HelpTip>
      <section className="role-links">
        {[
          ['/student', 'Murid', 'PR, listening, progres'],
          ['/teacher', 'Guru', 'Murid, assignment, scan'],
          ['/parent', 'Orang Tua', 'Anak, progres, laporan'],
          ['/admin', 'Admin', 'Pengguna, kurikulum, konten'],
        ].map(([to, title, desc]) => (
          <Link key={to} to={to} className="role-link">
            <article className="card"><h2>{title}</h2><p className="muted">{desc}</p></article>
          </Link>
        ))}
      </section>
    </main>
  );
}
